import { Component, ViewChild, OnInit } from '@angular/core';
import { ConsolidacionDialogBoxComponent } from './dialog/consolidacion-dialog-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { EvaluacionService } from '../../services/evaluacion.service';
import { Consolidacion } from 'app/main/models/consolidacion.model';
import { Router,ActivatedRoute } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDrawer } from '@angular/material/sidenav';
import { MatPaginator, PageEvent } from "@angular/material/paginator";

const ELEMENT_DATA: Consolidacion[] = [];

@Component({
    selector   : 'consolidacion',
    templateUrl: './consolidacion.component.html',
    styleUrls  : ['./consolidacion.component.scss']
})
export class ConsolidacionComponent
{
    displayedColumns: string[] = ['nombre','version','estructuraJerarquica','creador','responsable','fechaInicio','fechaFin','action'];
    dataSource: Consolidacion[] = [];
    role = [];
    titulo = "Consolidaciones";
    filterForm: FormGroup;

    basicSlice = 10;
    elementCount = 0;

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


    constructor(public dialog: MatDialog,
                private _fuseProgressBarService: FuseProgressBarService,
                private storage: TokenStorageService,
                private service: EvaluacionService,
                public router: Router,
                private _snackBar: MatSnackBar,
                private _formBuilder: FormBuilder,
                public translate: TranslateService,
                private route: ActivatedRoute) {}

    ngOnInit() {
      this.filterForm = this._formBuilder.group({});
      this.service.countConsolidaciones(this.filterForm).subscribe(req => {
        this.elementCount = req.body;
      });
      this.getElements(0);
    }

    loadData():void{
      this.getElements(0);
    }

    getElements(pageIndex){

      this.dataSource = [];
      var user = this.storage.getUser();
      this.role = this.storage.getRole();
      this._fuseProgressBarService.show();
      this.filterForm.value["pagina"] = pageIndex;
      this.filterForm.value["cantidad"] = this.basicSlice;

      this.service.getConsolidacionesAll(this.filterForm).pipe().subscribe(req => {


        req.body.map( consolidacion => {

          var consolidacionData = {
            id: consolidacion.id,
            nombre: consolidacion.nombre,
            version: consolidacion.version,
            estructuraJerarquica: consolidacion.estructuraJerarquica,
            fechaCreado: consolidacion.fechaCreado,
            nodoEstructuraJerarquica: consolidacion.nodoEstructuraJerarquica,
            responsable: consolidacion.responsable,
            fechaInicio: consolidacion.fechaInicio,
            fechaFin: consolidacion.fechaFin,
            tipo: consolidacion.tipo,
            creador: consolidacion.creador,
            escenario: consolidacion.escenario,
            ponderacionesPorEvaluacion: consolidacion.ponderacionesPorEvaluacion,
            ponderacionesPorObjetivo: consolidacion.ponderacionesPorObjetivo,
            objetivos: [],
            dimensiones: [],
            riesgos: [],
            usuarios:[],
            factorPonderacion: null,
            evaluaciones: [],
            tieneEliminar: (user==consolidacion.creador.correoElectronico &&
              (this.role.includes(4) || this.role.includes(2) || this.role.includes(5))),
            tieneEditar: this.role.includes(2) || this.role.includes(1) || (user==consolidacion.creador.correoElectronico || user==consolidacion.responsable.correoElectronico)
          };

          this.dataSource.push(consolidacionData);
        });

        this.dataSource = [...this.dataSource];

        this._fuseProgressBarService.hide();
      });
    }


    openDialog(action,obj): void {
      obj.action = action;
      const dialogRef = this.dialog.open(ConsolidacionDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Delete') {
          this.deleteRowData(result.data);
        }
      });
    }

    deleteRowData(row_obj): void {
      this.service.deleteConsolidacion(row_obj.id).pipe(first()).subscribe(
        data => {
          console.log(data);
          this.dataSource = this.dataSource.filter((value, key) => {
            return value.id !== row_obj.id;
          });

          this.dataSource = [...this.dataSource];

          this.openSnackBar("Se eliminó la consolidación correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo eliminar la consolidación, ocurrió un error.","Cerrar");
        }
      );
    }

    navegateTo(url, id): void  {
        this.router.navigate([url, id]).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }

    OnePageChange(event: PageEvent) {
      this.basicSlice = event.pageSize;
      this.getElements(event.pageIndex);
    }


}
